import { render, staticRenderFns } from "./DialogProduct.vue?vue&type=template&id=72c02d6e&"
import script from "./DialogProduct.vue?vue&type=script&lang=js&"
export * from "./DialogProduct.vue?vue&type=script&lang=js&"
import style0 from "./DialogProduct.vue?vue&type=style&index=0&id=72c02d6e&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports